import { toLocalDateString } from './localDate';

/** A date range as the birthdays API takes it: yyyy-MM-dd, both days included. */
export interface DateRange {
  from: string;
  to: string;
}

const addDays = (date: Date, days: number): Date => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

export const todayRange = (today: Date = new Date()): DateRange => {
  const day = toLocalDateString(today);
  return { from: day, to: day };
};

/** Today and the six days after it. */
export const nextSevenDaysRange = (today: Date = new Date()): DateRange => ({
  from: toLocalDateString(today),
  to: toLocalDateString(addDays(today, 6))
});

/** A whole calendar month; `month` is 1-12. */
export const monthRange = (year: number, month: number): DateRange => ({
  from: toLocalDateString(new Date(year, month - 1, 1)),
  to: toLocalDateString(new Date(year, month, 0))
});

/** yyyy-MM-dd as a local date (no UTC shift). */
export const parseLocalDate = (value: string): Date => {
  const [y, m, d] = value.split('-').map(Number);
  return new Date(y, m - 1, d);
};

/** "Today", "Tomorrow", or "Thu 2 Oct". */
export const describeBirthday = (value: string, today: Date = new Date()): string => {
  const day = parseLocalDate(value);
  const todayStr = toLocalDateString(today);
  if (value === todayStr) return 'Today';
  if (value === toLocalDateString(addDays(today, 1))) return 'Tomorrow';
  return day.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
};
